module.exports = __webpack_public_path__ + "static/media/new-tag.4462a5b4.svg";